import * as React from 'react';
import { lazyInject } from '../../ioc';
import styles from './opt-in-page.less';
import { Card, Headline } from '@servicetitan/design-system';
import { observer } from 'mobx-react';
import { OptInStore } from 'src/marketing/stores/opt-in.store';

@observer
export class OptInPage extends React.Component<{}> {
    @lazyInject(OptInStore) private marketingStore!: OptInStore;

    componentDidMount(): void {
        this.marketingStore.optIn();
    }

    render() {
        return (
            <div>
                <Card raised>
                    <Card.Section className="p-x-5 p-y-4">
                        <div className={styles.successContainer}>
                            <div className={styles.successImages}>
                                <img src="/assets/images/mrk-subs-circle.svg" />
                                <img src="/assets/images/mrk-subs-check.svg" />
                            </div>
                            <Headline className="m-t-3">
                                Your preferences have been updated.
                            </Headline>
                        </div>
                    </Card.Section>
                </Card>
            </div>
        );
    }
}
